export const frameLinks = {
  spatialInsights: 'https://www.youtube.com/embed/wHOR28evPFk',
};
